import * as React from "react";
import { forwardRef, memo } from "react";
const SvgDj = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 15 10", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#6ab2e7", d: "M0 0h15v10H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#12ad2b", d: "M0 5h15v5H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v10l4.33-2.5L8.66 5 4.33 2.5 0 0z", fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M3.314 3.75l.31.955H4.63l-.813.59.31.955-.812-.59-.812.59.31-.955L2 4.705h1.004l.31-.955z", fill: "#d7141a" }));
const ForwardRef = forwardRef(SvgDj);
const Memo = memo(ForwardRef);
export default Memo;
